import { gql, useQuery } from "@apollo/client";

export const Clients = gql`
	query Clients($term: String, $limit: Int, $offSet: Float) {
		clients(input: { term: $term, limit: $limit, offSet: $offSet }) {
			data {
				_id
				email
				name
				phoneNumber
				addressInfo {
					Address
					postalCode
				}
				localidade
				nif
				avatar
				createdAt
			}
			paginantionInfo {
				numberDocuments
				currentSkip
			}
		}
	}
`;
